module.exports = __webpack_public_path__ + "img/new-survey.df04d466.png";